<template>
  <div>
    <Modal
      :showFooter="true"
      modalName="Delete Recipient List"
      v-show="isActive"
      @confirmAction="handleDelete"
      @hideModal="$emit('hideModal')"
      buttonLabel="Delete"
      colorVariation="secondary"
    >
      <template slot="header">
        <h4 class="header editorial">Delete List</h4>
      </template>

      <template slot="body">
        <div>
          <p class="modal-description">
            You are about to delete '{{ data.file_name }}' from recipient lists.
          </p>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/components/Universal/RemoveModal'
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },

    data: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    Modal
  },

  methods: {
    async handleDelete() {
      this.$emit('hideModal')
      this.$store.dispatch('recipient/handleDeleteRecipientList', this.data.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.header {
  font-size: 2rem;
  font-weight: normal;
  padding-bottom: 1rem;
  color: #25282a;
}

.modal-description {
  color: #25282a;
}
</style>
